<template>
  <document-container
    :header="header"
    :logo="logo"
    :tables="tables"
    :timeout="12000"
    documentType="equivalence-check"
  >

    <div
      slot="raw-body"
      class="page-block"
    >
      <div
        style="font-size: 12px"
      >
        <h2 v-if="mainLabel" class="product-table-title">{{ mainLabel }}</h2>
        <p v-if="listTitle"><strong>Vergleichsliste:</strong> {{ listTitle }}</p>
        <template v-if="!skipMessage">
          <p v-if="count === 1">Es wurde <strong>1 äquivalentes Produkt</strong> gefunden.</p>
          <p v-if="count > 1">Es wurden <strong>{{ count }} äquivalente Produkte</strong> gefunden.</p>
          <p v-if="count === 0">Es wurden <strong>keine äquivalenten Produkte</strong> gefunden.</p>
        </template>
        <template v-else>
          <p>{{ skipMessage }}</p>
        </template>
        <p v-if="count === 0">{{ moment().format('[Stand:] DD. MMMM YYYY, HH:mm [Uhr]') }}</p>
        <hr style="margin-bottom: 0">
        <p v-if="comment" style="margin-top: 15px">{{ comment }}</p>
      </div>
    </div>
    <div
      v-if="tables"
      slot="raw-body"
      class="page-block"
    >
      <product-table
        v-if="products.length > 0"
        :id="'product-table'"
        :table="tables.findTable('product-table')"
      ></product-table>
    </div>

  </document-container>
</template>

<script>
import DocumentContainer from '../document/DocumentContainer'
import BlockMixin from '../block/BlockMixin'
import ProductTable from '../table/TableOnepagerProducts.vue'
import {Table,} from '../../model/table/Table'
import {TableCollection,} from '../../model/table/TableCollection'
import ProductService from "../../service/ProductService"
import TokenService from "../../service/TokenService"
import get from "lodash/get";

export default {
  name: 'equivalence-check-product',

  data() {
    return {
      ProductTable,
      columns: [
        {
          "label": "ISIN",
          "info": null,
          "path": "ids.isin",
          "decorator": "text",
          "decoratorOptions": null,
          "sortPath": "ids.isin",
          "initialOrder": "ASC",
          "weight": 2,
          "pathToStyleHints": null,
          "splitIndicator": "NONE",
        },
        {
          "label": "Bezeichnung",
          "info": null,
          "path": "name",
          "decorator": "text",
          "decoratorOptions": null,
          "sortPath": null,
          "initialOrder": null,
          "weight": 3,
          "pathToStyleHints": null,
          "splitIndicator": "NONE",
        },
        {
          "label": "Kosten",
          "info": null,
          "path": "derived.bison.costs",
          "decorator": "percent",
          "decoratorOptions": {
            "format": "1.2-2",
            "styleHints": [
              "right-aligned",
            ],
          },
          "sortPath": null,
          "initialOrder": null,
          "weight": 1,
          "pathToStyleHints": null,
          "splitIndicator": "NONE",
        },
        {
          "label": "Kommentar",
          "info": null,
          "path": "comment",
          "decorator": "text",
          "decoratorOptions": null,
          "sortPath": null,
          "initialOrder": null,
          "weight": 8,
          "pathToStyleHints": null,
          "splitIndicator": "NONE",
        },
      ],
      products: null,
      tables: null,
      token: null,
      isin: null,
      comment: null,
      count: null,
      listTitle: null,
      mainLabel: null,
      skipMessage: null,
    }
  },

  props: {
    environment: {
      type: String,
      required: true,
    },
    ecId: {
      type: String,
      required: true,
    },
    appInstance: {
      type: String,
      required: false,
    },
  },

  methods: {
    fetchProducts() {
      ProductService.getProductEquivalenceCheck(
        this.environment,
        this.appInstance,
        this.ecId,
        this.token,
      ).then(productsResponse => {
        let res = productsResponse.data.resultEntry

        this.products = Object.keys(res.equivalentProducts).map(el => {
          return {
            ...res.equivalentProducts[el], comment: res.equivalentDqsToComments[res.equivalentProducts[el].dq]
          }
        })
        this.comment = res.comment
        this.count = Object.keys(this.products).length
        this.listTitle = get(productsResponse.data, 'referenceListLabel', null)
        this.skipMessage = get(productsResponse.data, 'skipMessage', null)
        this.mainLabel = `${res.referenceProduct.name || ''} (${res.referenceProduct.ids.isin})`

        if (this.hideCosts) {
          this.columns.splice(2, 1)
        } else {
          this.mainLabel += ` — Kosten: ${res.referenceProduct.derived.bison.costs} %`
        }

        let productTables = [
          new Table(
            'product-table',
            this.columns,
            this.products,
            ProductTable,
            null,
          ),
        ]

        this.tables = new TableCollection(...productTables)
      })
    },
  },

  head: {
    link: function () {
      return [
        {
          rel: 'stylesheet',
          href: '/config/' + this.environment + '/style/equivalence_check.css',
        },
      ]
    },
  },

  mixins: [BlockMixin],

  async created() {
    if (this.$route.query.token) {
      this.token = this.$route.query.token
    } else {
      this.token = await TokenService.checkToken()
    }
    this.fetchProducts()
  },

  computed: {
    hideCosts() {
      return ['QQD3VPHD', 'QQD3VBHA'].includes(this.appInstance)
    },
    logo() {
      return '/config/' + this.environment + '/images/logo.png'
    },
    header() {
      return [{
        type: 'Pagetitle',
        title: 'Äquivalenzcheck',
        position: 'header',
        sort: 1,
        shared: true,
      }]
    }
  },

  components: {
    DocumentContainer,
    ProductTable,
  },
}
</script>



// WEBPACK FOOTER //
// ProductEquivalenceCheck.vue?4b1d28f3